import { FnParam } from '@angular/compiler/src/output/output_ast';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { format, addHours } from 'date-fns';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AuthService } from '../api-services/Auth/auth.service';
import { DoctorServiceService } from '../api-services/doctor-service.service';
import { ProfileService } from '../api-services/profile/profile.service';
import { TalkToDoctorService } from '../api-services/talk-to-doctor.service';
/**
 * This component is maintain for doctor profile information.
 * Here,doctor can edit is profile info and update profile.
 */
@Component({
  selector: 'app-doctor-profile',
  templateUrl: './doctor-profile.component.html',
  styleUrls: ['./doctor-profile.component.css'],
})
export class DoctorProfileComponent implements OnInit {
  @ViewChild('msg') modalDialog;
  bsRef: BsModalRef;
  gender: any;
  specaiality_list: any;
  languageList: any;
  ddSettingsToSpeak: IDropdownSettings;
  ddSettingsToSW: IDropdownSettings;
  ddSettingToSpecilities: IDropdownSettings;
  getInfo: any;
  doctorForm = new FormGroup({
    firstName: new FormControl('', [
      Validators.required,
      Validators.minLength(3),
      Validators.maxLength(35),
      Validators.pattern("^[a-zA-Z -']+"),
    ]),
    lastName: new FormControl('', [
      Validators.required,
      Validators.minLength(3),
      Validators.maxLength(35),
      Validators.pattern("^[a-zA-Z -']+"),
    ]),
    email: new FormControl(''),
    password: new FormControl(''),
    mobile: new FormControl('', [
      Validators.required,
      Validators.maxLength(10),
      Validators.minLength(10),
      Validators.pattern(/^-?(0|[1-9]\d*)?$/),
    ]),
    dob: new FormControl('', [Validators.required]),
    genderId: new FormControl('', [Validators.required]),
    addrLine1: new FormControl('', [Validators.required]),
    addrLine2: new FormControl('', []),
    availabilityStartTime: new FormControl(''),
    availabilityEndTime: new FormControl(''),
    languagesKnownSpeak: new FormControl('', [Validators.required]),
    languagesKnownReadWrite: new FormControl('', [Validators.required]),
    doctorSpecialities: new FormControl('', [Validators.required]),
    subspeciality: new FormControl(null),
    graduatedegree: new FormControl('', [Validators.required]),
    graduatecollege: new FormControl(''),
    postgraduatedegree: new FormControl('', []),
    postgraduatecollege: new FormControl('', []),
    othercertification: new FormControl('', []),
    othercertificationcollege: new FormControl('', []),
    experienceFrom: new FormControl('', []),
    country: new FormControl('', [Validators.required]),
    state: new FormControl('', [Validators.required]),
    city: new FormControl('', [Validators.required]),
    zip: new FormControl(''),
    credentials: new FormControl(),
    uploadedProofIds: new FormControl(null),
    doctorId: new FormControl(),
  });
  setTimings: FormGroup;
  testbool = false;
  maxdate: any;
  startAt: Date;
  endAt: Date;
  checkTime: boolean;
  getTime: any;
  getTime1: any;
  countries: any;
  states: any;
  cities: any;
  constructor(
    private doctorProfile: ProfileService,
    private genderService: TalkToDoctorService,
    private doctor_service: DoctorServiceService,
    private modal: BsModalService,
    private updateProfileName: AuthService,
    private cdRef: ChangeDetectorRef
  ) {
    this.getDoctorProfile();
  }

  ngOnInit(): void {
    let date = new Date();
    this.startAt = new Date(new Date().setHours(4, 0, 0));
    this.endAt = new Date(new Date().setHours(24, 0, 0));
    this.maxdate = new Date(
      `${date.getMonth() + 1}-${date.getDate()}-${date.getFullYear() - 18}`
    );
    this.genderService.getGender().subscribe((res) => {
      this.gender = res;
    });

    this.doctor_service
      .getCountry()
      .subscribe((data: any) => (this.countries = data));
    this.setTimings = new FormGroup(
      {
        startTime: new FormControl('', [Validators.required]),
        endTime: new FormControl('', [Validators.required]),
      },
      {
        validators: (control) => {
          if (control.value.startTime && control.value.endTime) {
            let startTime = format(
              this.setTimings.get('startTime').value,
              'HH'
            );
            let endTime = format(this.setTimings.get('endTime').value, 'HH');
            if (startTime >= endTime) {
              control.get('startTime').setErrors({ greaterValue: true });
            } else {
              control.get('startTime').setErrors(null);
            }
          }
          return null;
        },
      }
    );

    //This api call for get doctors specialzation information and
    // display on specialization input field
    this.doctor_service.getSpecilities().subscribe((data: any) => {
      this.specaiality_list = data;
    });
    //This api call for get doctors known language information and
    // display on known language input field
    this.doctor_service.getLanguagesList().subscribe((data) => {
      this.languageList = data;
    });
    //Below Objects to select multiple dropdown items configuration
    this.ddSettingsToSpeak = {
      singleSelection: false,
      idField: 'id',
      textField: 'languageName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      // itemsShowLimit: 3,
      allowSearchFilter: true,
    };

    this.ddSettingsToSW = {
      singleSelection: false,
      idField: 'id',
      textField: 'languageName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
    };
    this.ddSettingToSpecilities = {
      singleSelection: false,
      idField: 'id',
      textField: 'specialityName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
    };
  }

  changeTime(str) {
    if (str == 'availabilityStartTime') {
      this.getTime = this.setTimings.get('startTime').value;
      let startTime = format(this.setTimings.get('startTime').value, 'HH');
      this.doctorForm.get('availabilityStartTime').patchValue(startTime);
    } else {
      this.getTime1 = this.setTimings.get('endTime').value;
      let endTime = format(this.setTimings.get('endTime').value, 'HH');
      this.doctorForm.get('availabilityEndTime').patchValue(endTime);
    }
  }

  getState(CountryId: any) {
    this.doctor_service.getState(CountryId).subscribe((data) => {
      this.states = data;
    });
  }
  getCity(StateId: any) {
    this.doctor_service
      .getCity(StateId)
      .subscribe((data) => (this.cities = data));
  }
  /**
   * This method can access doctor information and display on input fields respectively
   */
  getDoctorProfile() {
    this.doctorProfile.getDoctorProfile().subscribe((res) => {
      this.getInfo = res;
      let setEndTime = new Date(
        new Date().setHours(this.getInfo.availabilityEndTime, 0)
      );

      let setStartTime = new Date(
        new Date().setHours(this.getInfo.availabilityStartTime, 0)
      );
      this.getTime = setStartTime;
      this.getTime1 = setEndTime;
      this.getState(this.getInfo.country);
      this.getCity(this.getInfo.state);
      this.setTimings.get('startTime').patchValue(setStartTime);
      this.setTimings.get('endTime').patchValue(setEndTime);
      this.doctorForm.get('firstName').patchValue(this.getInfo.firstName);
      this.doctorForm.get('addrLine1').patchValue(this.getInfo.addrLine1);
      this.doctorForm.get('dob').patchValue(this.getInfo.dob);
      this.doctorForm.get('email').patchValue(this.getInfo.email);
      this.doctorForm.get('genderId').patchValue(this.getInfo.genderId);
      this.doctorForm
        .get('languagesKnownReadWrite')
        .patchValue(this.getInfo.languagesKnownReadWrite);
      this.doctorForm
        .get('languagesKnownSpeak')
        .patchValue(this.getInfo.languagesKnownSpeak);
      this.doctorForm
        .get('doctorSpecialities')
        .patchValue(this.getInfo.doctorSpecialities);
      this.doctorForm
        .get('graduatecollege')
        .patchValue(this.getInfo.graduatecollege);
      this.doctorForm
        .get('graduatedegree')
        .patchValue(this.getInfo.graduatedegree);
      this.doctorForm.get('lastName').patchValue(this.getInfo.lastName);
      this.doctorForm.get('mobile').patchValue(this.getInfo.mobile);
      this.doctorForm.get('password').patchValue(this.getInfo.password);
      this.doctorForm
        .get('postgraduatecollege')
        .patchValue(this.getInfo.postgraduatecollege);
      this.doctorForm
        .get('postgraduatedegree')
        .patchValue(this.getInfo.postgraduatedegree);
      this.doctorForm.get('credentials').patchValue(this.getInfo.credentials);
      this.doctorForm.get('doctorId').patchValue(this.getInfo.doctorId);
      this.doctorForm
        .get('experienceFrom')
        .patchValue(this.getInfo.experienceFrom);
      this.doctorForm
        .get('availabilityEndTime')
        .patchValue(this.getInfo.availabilityEndTime);
      this.doctorForm
        .get('availabilityStartTime')
        .patchValue(this.getInfo.availabilityStartTime);
      setTimeout(() => {
        this.doctorForm.get('country').patchValue(this.getInfo.country);
        this.doctorForm.get('state').patchValue(this.getInfo.state);
        this.doctorForm.get('city').patchValue(this.getInfo.city);
      }, 500);
    });
  }
  /**
   * This method can access doctor editable information and post into server.
   * If response come as successful or true ,to call 'getDoctorProfile'
   * method to display update information.
   */
  updateProfile() {
    if (!this.doctorForm.valid || !this.setTimings.valid) {
      this.doctorForm.markAllAsTouched();
    } else {
      this.doctorProfile.editDoctorProfile(this.doctorForm.value).subscribe(
        (res) => {
          if (res) {
            this.getDoctorProfile();
            this.modal.show(this.modalDialog, {
              backdrop: 'static',
              initialState: {
                message: 'Profile has been successfully updated',
              },
            });
            this.updateProfileName.setUpdateName({
              firstName: this.doctorForm.get('firstName').value,
            });
            this.doctorForm.get('firstName').value;
          }
        },
        (err) => {}
      );
    }
  }

  modalopen() {
    this.modal.show(this.modalDialog, {
      backdrop: 'static',
    });
  }

  modalClose() {
    this.modal.config.initialState = '';
    this.modal.hide();
  }
}
